import * as React from 'react';
import './TileStrip.scss';

export const TileStrip: React.FC<React.PropsWithChildren<{}>> = ({children}) => (
  <div className="home-tile-strip">
      {children}
  </div>
);
